import { render, staticRenderFns } from "./supplierAssemblyPriceList.vue?vue&type=template&id=c239241a&"
import script from "./supplierAssemblyPriceList.vue?vue&type=script&lang=js&"
export * from "./supplierAssemblyPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports